export default __webpack_public_path__ + "static/media/icons8-help-48.b91ffbeb.svg";